import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { IncidentService } from 'src/app/services/incident.service';
import { Subscription } from 'rxjs';
import { DropdownService } from 'src/app/services/dropdown.service';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  loading = false;
  headerImage = "url('assets/images/dashBanner.png')";
  currentYear = new Date().getFullYear();
  public version: string = packageJson.version;


  cardsBlockA = [
    {
      title: 'Master Action',
      description: 'View Incidents',
      route: 'incidents',
      class: 'orange',
    },
    {
      title: 'Master Action',
      description: 'Create Incident',
      route: 'incidents/new',
      class: 'orange',
    },
    {
      title: 'Master Action',
      description: 'Generate Report',
      route: 'reports',
      class: 'orange',
    },
    {
      title: 'MARS',
      description: 'View Incidents',
      route: 'mars/search',
      class: 'blue',
    },
    {
      title: 'MARS',
      description: 'Create Incident',
      route: 'mars/incident/new',
      class: 'blue',
    },
    {
      icon: 'assets/icons/airplane.svg',
      stat: '0',
      statDetail: 'current active pilots',
      class: 'stat-card',
      alt: 'airplane'
    },
    {
      image: "assets/images/tanker.png",
      alt: 'tanker',
      class: 'no-padding',
      imgClass: 'pic1'
    },
    {
      icon: 'assets/icons/forest-fire.svg',
      class: 'double',
      stat: '0',
      statDetail: `Master Actions in ${this.currentYear}`,
      alt: 'forest fire'
    },
  ];
  
  cardsBlockB = [
    {
      image: 'assets/images/jumper-profile.jpg',
      class: 'double-square',
      imgClass: 'pic2',
      alt: 'smokejumper',
    },
    {
      image: "assets/images/jumpersinplane.jpg",
      alt: 'jumpers in plane',
      class: 'no-padding',
      imgClass: 'pic3'
    },
    {
      icon: 'assets/icons/jumper.svg',
      stat: '0',
      statDetail: 'current active jumpers',
      class: 'stat-card',
      alt: 'jumper'
    },
  ]
    
  cardsBlockC = [
    {
      icon: 'assets/icons/us_map.svg',
      stat: '0',
      statDetail: 'bases across the United States',
      class: 'stat-card',
      alt: 'us map'
    },
    {
      image: "assets/images/ncsb.jpg",
      alt: 'tanker',
      class: 'no-padding',
      imgClass: 'pic4'
    },
    {
      icon: 'assets/icons/fire.svg',
      stat: '0',
      statDetail: `MARS in ${this.currentYear}`,
      class: 'stat-card',
      alt: 'fire'
    },
  ]

  dashboardStatsSubscription: Subscription;

  constructor(private router: Router, private incidentService: IncidentService, private dropdownService: DropdownService) { }

  ngOnInit(): void {
    this.dashboardStatsSubscription = this.dropdownService.getDashboardStats().subscribe({
      next: (response) => {
        this.cardsBlockC[0].stat = response.basesCount;
        this.cardsBlockA[5].stat = response.currentActivePilots;
        this.cardsBlockB[2].stat = response.currentActiveJumpers;
        this.cardsBlockA[7].stat = response.masterActionsForYear ;
        this.cardsBlockC[2].stat = response.marsForYear;
      },
      error: (error) => {
        console.error(error);
      }
    });

  }

  go = (route: any) => {
    this.router.navigate([route]);
  };

  ngOnDestroy() {
    this.dashboardStatsSubscription.unsubscribe();
  }
}
